<template>
  <base-details-header :structure="headerStructure" :el="selectedLocation" />
  <base-subpage-bar :headers="headers" />
  <router-view />
</template>

<script>
  import { computed, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { useStore } from 'vuex';
  export default {
    setup() {
      //  INIT
      const store = useStore();
      const route = useRoute();
      //  ASSIGN ELEMENTS
      const selectedElID = { id: route.params.locationId };
      onMounted(() => {
        store.dispatch('getSelectedLocation', selectedElID);
        store.dispatch('getLocationVehicles', { location: route.params.locationId });
      });
      const selectedLocation = computed(() => {
        return store.getters.selectedLocation;
      });
      //  CREATE OBJ FOR DETAILS HEADER
      const headers = [
        {
          text: 'paths.overall',
          name: 'menu.sharing.locationDetails',
        },
        {
          text: 'views.managers.linkedVehicles',
          name: 'menu.sharing.locationVehicles',
        },
      ];

      const headerStructure = {
        title: [
          {
            title: 'name',
          },
        ],
        data: [
          {
            name: 'id',
            placeholder: '@',
          },
          {
            name: 'address',
          },
        ],
      };
      return {
        selectedLocation,
        headerStructure,
        headers,
      };
    },
  };
</script>
<style></style>
